export function getNamaBulan(b) {
  const n = parseInt(b, 10);

  const list = {
    1: "Januari",
    2: "Februari",
    3: "Maret",
    4: "April",
    5: "Mei",
    6: "Juni",
    7: "Juli",
    8: "Agustus",
    9: "September",
    10: "Oktober",
    11: "November",
    12: "Desember",
  };

  return list[n] || "-";
}

export function formatDateIndo(dateStr) {
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.getMonth() + 1; // Months are zero-based
  const year = date.getFullYear();

  return `${day} ${getNamaBulan(month)} ${year}`;
}

export function formatRupiah(amount) {
  return `Rp ${Number(amount).toLocaleString("id-ID")}`;
}

export function parseRupiah(rupiahStr) {
  // Remove "Rp" and any dots or commas
  const cleaned = rupiahStr.replace(/Rp\s?|[.,]/g, "");
  return parseFloat(cleaned);
}

export function calculateTotal(bills) {
  return bills.reduce((total, bill) => total + Number(bill.amount || 0), 0);
}

export function filterBillsByYear(bills, year) {
  return bills.filter(bill => bill.cardyear === year);
}

export function getUniqueYears(bills) {
  const years = bills.map(bill => bill.cardyear);
  return Array.from(new Set(years)).sort();
}

export function sortBillsByMonth(bills) {
  return bills.slice().sort((a, b) => a.cardmonth - b.cardmonth);
}

export function groupBillsByYear(bills) {
  return bills.reduce((acc, bill) => {
    if (!acc[bill.cardyear]) {
      acc[bill.cardyear] = [];
    }
    acc[bill.cardyear].push(bill);
    return acc;
  }, {});
}
export function formatDateTimeIndo(dateStr) {
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.getMonth() + 1; // Months are zero-based
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day} ${getNamaBulan(month)} ${year} ${hours}:${minutes}`;
}
export const parseColumnStyle = (styleCode) => {
  const type = styleCode.substring(0, 1);
  const width = parseInt(styleCode.substring(1));
  return { type, width };
};

export const formatValue = (type, value) => {
  if (value == null) return "";

  switch (type) {
    case "D":
      return new Date(value).toLocaleDateString("id-ID");
    case "E":
      return new Date(value).toLocaleString("id-ID");
    case "N":
      return Number(value).toLocaleString("id-ID");
    default:
      return value;
  }
};


export function getInitials(name) {
  // const words = name.trim().split(" ");
  // if (words.length === 1) return words[0][0]?.toUpperCase();
  // return (words[0][0] + words[1][0]).toUpperCase();
  if (!name) return "";

  // 1. Remove anything inside parentheses
  const cleanName = name.replace(/\(.*?\)/g, "").trim();

  // 2. Split by spaces
  const words = cleanName.split(/\s+/);

  // 3. Logic
  if (words.length === 1) {
    // Single word → take first 2 letters
    return words[0].substring(0, 2).toUpperCase();
  }

  // More than one word → first letter of first & second word
  return (words[0][0] + words[1][0]).toUpperCase();
};

export function stringToColor(str) {
  try {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 65%, 55%)`;
  } catch (error) {
    return "gray";
  }
};

export function stringToSoftColor(str, alpha = 0.2) {
  const base = stringToColor(str);
  return base.replace("hsl", "hsla").replace(")", `, ${alpha})`);
}


export function hitungUmur(tanggalLahir) {
  if (!tanggalLahir) return "Umur N/A";

  const lahir = new Date(tanggalLahir);
  const today = new Date();

  let umur = today.getFullYear() - lahir.getFullYear();
  const m = today.getMonth() - lahir.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < lahir.getDate())) {
    umur--;
  }

  return `${umur} Tahun`;
};


const DataHelper = {
  getNamaBulan,
  formatDateIndo,
  formatRupiah,
  parseRupiah,
  calculateTotal,
  filterBillsByYear,
  getUniqueYears,
  sortBillsByMonth,
  groupBillsByYear,
  formatDateTimeIndo,
  parseColumnStyle,
  formatValue,
  getInitials,
  stringToColor,
  hitungUmur,
};

export default DataHelper;